import styled from "styled-components";

export const AddDetentionContainer = styled.div`
  padding: 0 20px;
`;
